import React, { ReactNode } from 'react'
import { Image, TextStyle, View } from 'react-native'
import { composeStyle } from '../../helpers'
import { BtButton, BtButtonProps } from '../BtButton'
import { Layout, Modal } from '@ui-kitten/components'
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons'
import { BtText } from '../BtText'
import { Spacer } from '../Spacer'
import { useResponsive } from '../../hooks'

const IconSuccess = require('./icons/Success.png')
const IconWarning = require('./icons/Warning.png')
const IconDanger = require('./icons/Danger.png')

type IconType = 'default' | 'warning' | 'danger' | 'success'

type IconProps = {
  type: IconType
  icon?: any
}

const Icon = ({ type, icon }: IconProps) => {
  if (icon) return icon
  let _icon

  if (type === 'warning') _icon = IconWarning
  if (type === 'danger') _icon = IconDanger
  if (type === 'success') _icon = IconSuccess
  if (_icon) {
    return (
      <Image
        style={{ resizeMode: 'cover', height: 70, width: 70, marginBottom: 10 }}
        source={_icon.hasOwnProperty('default') ? _icon.default : _icon}
      />
    )
  }
  return null
}

interface ButtonProps extends BtButtonProps {
  label: string
  onPress: () => void
  style?: any
  testID?: string
}

export interface BtAlertProps {
  size?: 'default' | 'small'
  visible: boolean
  onClose: () => void
  buttons: ButtonProps[]
  title?: string | ReactNode
  type?: IconType
  onBackdropPress?: () => void
  children?: ReactNode
  titleStyle?: TextStyle
  width?: number | string
  height?: number | string
  icon?: any
  verticalButtons?: boolean
  noCloseIcon?: boolean
  onBack?: () => void
  margins?: number
  buttonsContainerStyle?: any
}

export const BtAlert = ({
  type = 'default',
  visible,
  onClose,
  title,
  buttons,
  onBackdropPress,
  children,
  width,
  height,
  icon,
  titleStyle,
  verticalButtons,
  noCloseIcon = false,
  margins,
  buttonsContainerStyle,
}: BtAlertProps) => {
  const { sm } = useResponsive()
  return (
    <Modal
      visible={visible}
      onBackdropPress={onBackdropPress || onClose}
      backdropStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
    >
      <Layout
        style={composeStyle(
          {
            borderRadius: 12,
            minWidth: 300,
            minHeight: 200,
            padding: 20,
          },
          width && { minWidth: width },
          height && { minHeight: height },
          margins && { marginHorizontal: margins },
        )}
      >
        {noCloseIcon ? null : (
          <View style={{ width: '100%', alignItems: 'flex-end' }}>
            <MaterialCommunityIcons
              name={'close'}
              color={'#003353'}
              size={14}
              style={{
                backgroundColor: '#F5F7F8',
                padding: 10,
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 5,
              }}
              onPress={onClose}
              testID="close"
            />
          </View>
        )}

        <View style={{ alignItems: 'center' }}>
          {type ? <Icon type={type} icon={icon} /> : null}
          {typeof title === 'string' ? (
            <BtText
              size={sm ? 28 : 18}
              weight={'600'}
              style={[
                {
                  width: '100%',
                  lineHeight: sm ? 36 : 28,
                  textAlign: 'center',
                },
                titleStyle,
              ]}
            >
              {title}
            </BtText>
          ) : (
            title
          )}
          <Spacer />
          {children}
        </View>
        <Spacer height={20} />
        <View
          style={composeStyle(
            {
              flexDirection: verticalButtons ? 'column' : 'row',
              width: '100%',
              justifyContent: 'space-evenly',
              marginBottom: verticalButtons ? 0 : 20,
            },
            buttonsContainerStyle,
          )}
        >
          {buttons?.map((button, index) =>
            button.label ? (
              <View key={index}>
                <BtButton {...button}>{button.label}</BtButton>
                {verticalButtons && <Spacer height={13} />}
              </View>
            ) : null,
          )}
        </View>
      </Layout>
    </Modal>
  )
}
